import React, { useRef } from 'react'
import { Container, Row, Col } from 'reactstrap';
import { Formik, Form } from "formik";
import * as Yup from 'yup';
import Select2 from "../../forms/Select2";
import MultiSelect from "../../forms/Select2Multi";


const FilterLocationItems = ({ action, data, toggle, match, filterCity, filterStore, cityOptions = [], storeOptions = [] }) => {
    const formikRef = useRef();

    const initial = data ? {
        // id: data?.id,
        city: filterCity || "",
        toko: filterStore || ""
    } : {
        city: filterCity || "",
        toko: filterStore || ""
    }

    const validation = Yup.object().shape({
        city: Yup.string().required("Pilih kota terlebih dahulu"),
        toko: Yup.string().required("Pilih toko terlebih dahulu"),
    })

    const initialTouched = {
        city: true,
        toko: true
    }

    

    return (
        <>
            <Formik
                innerRef={formikRef}
                initialValues={initial}
                enableReinitialize
                initialTouched={initialTouched}
                validationSchema={validation}
                onSubmit={(values, { setStatus, setSubmitting }) => {
                    setStatus();
                    let sendData = {
                        city : '',
                        store : ''
                    }
                    if(values.city === 'all'){
                        sendData.city = ''
                    } else {
                        sendData.city = values.city
                    }
                    sendData.store = values.toko
                    action(sendData);
                }}
            >
                {(props) => (
                    <Form>
                        <Container>
                            <div style={{marginBottom:20}}>
                                <Select2
                                    title="Toko"
                                    name="toko"
                                    options={storeOptions}
                                    errors={props?.errors}
                                    touched={props?.touched}
                                    value={props?.values?.toko}
                                    onChange={(name, value) => {
                                        props?.setFieldValue("toko", String(value));
                                    }}
                                    onBlur={props?.setFieldTouched}
                                />
                            </div>

                            <MultiSelect
                                title="Kota Asal"
                                name="city"
                                options={cityOptions}
                                errors={props?.errors}
                                touched={props?.touched}
                                value={props?.values?.city}
                                onChange={(name, value) => {
                                    props?.setFieldValue("city", String(value));
                                }}
                                onBlur={props?.setFieldTouched}
                                
                            />
                            {/* <Select2
                                name="city"
                                options={dataCity}
                                errors={props?.errors}
                                touched={props?.touched}
                                value={props?.values?.city}
                                onChange={(name, value) => {
                                    props?.setFieldValue("city", value);
                                }}
                                onBlur={props?.setFieldTouched}
                                
                            /> */}
                            
                            <Row style={{marginTop: 20, justifyContent:"end"}}>
                                <Col sm={7}>
                                    <button type="button" className="button-batal" onClick={toggle}>
                                        Batal
                                    </button>
                                    <button type="submit" className="button-simpan">
                                        Terapkan
                                    </button>
                                </Col>
                            </Row>
                        </Container>
                    </Form>
                )}
            </Formik>
        </>
    )
}


export default FilterLocationItems;
